import { status } from 'skin/event/status';

const row = (obj, ms, story, data, d, action) => {
	const key = story.s.msProT.table.propT.row
	if (obj.key === key) return status.ignore
	return status.action
}

export default row